var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-up 1",
    clipPath: "url(#clip0_35_80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.64646 17.3164L17.05 10.0285C17.4071 9.67701 17.4071 9.10716 17.05 8.75571L16.1865 7.9057C15.83 7.55481 15.2523 7.55413 14.895 7.9042L8.99995 13.6799L3.1049 7.90416C2.74761 7.5541 2.16989 7.55477 1.81344 7.90566L0.94993 8.75567C0.592864 9.10716 0.592864 9.67701 0.94993 10.0285L8.35347 17.3163C8.7105 17.6678 9.2894 17.6678 9.64646 17.3164Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0667,
    height: 19.2,
    fill: "white",
    transform: "matrix(-1 0 0 1 17.5333 0.333334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.999bf0f87e5e6c575c6ffd53dc9f7a6e.svg";
export { ForwardRef as ReactComponent };